import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { MenuItemStyled } from "@entrilia/shared/components/MenuItemStyled.tsx";
import { Box, Grid, Select, Tooltip, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import type { Grouping } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import { BiAggregation } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { DimensionField } from "../../../../../../../../api/types/svTypes.ts";
import { selectCurrentDataSetId } from "../../../../store/selectors/metaDataSelectors";
import { DataSetIds } from "../../../../utilities/DimensionNames";
import {
  defaultDateGrouping,
  getDateGroupingLabel,
} from "../../../viewer/common/fields/field-captions/captionsHelper.ts";

const emptyGroupingValue = "day";

interface Props {
  field: DimensionField;
  supportedDateGroupings?: (Grouping | null)[];
  updateGrouping: (newGrouping: Grouping | null) => void;
  getGroupingDisabledReason?: (grouping: Grouping | null) => string | undefined;
  readonly: boolean;
}

const DateGroupingComponent = ({
  field,
  supportedDateGroupings,
  updateGrouping,
  getGroupingDisabledReason,
  readonly,
}: Props) => {
  const dataSetId = useSelector(selectCurrentDataSetId);
  const isRangeSelectionDisabled = !!field.config.aggregation && field.config.aggregation !== BiAggregation.None;
  const groupings = supportedDateGroupings || defaultDateGrouping;

  // TODO: remove this once we have a proper way to handle data set id
  const isPortfolioMonitoring = dataSetId === DataSetIds.PortfolioMonitoring;

  return (
    <Grid container sx={{ alignItems: "center", px: 2, py: 1.5, width: "100%" }}>
      <Typography> {isPortfolioMonitoring ? "Reporting Period" : "Date Grouping"}</Typography>
      <HorizontalFill />
      <Select
        value={field.config.grouping ?? emptyGroupingValue}
        disabled={isRangeSelectionDisabled || readonly}
        sx={{ width: 208, ".MuiSelect-select": { py: 0.7 } }}
      >
        {groupings.map((item) => {
          const disabledReason = getGroupingDisabledReason?.(item ?? null);
          const label = <Typography variant="caption">{getDateGroupingLabel(item)}</Typography>;
          return (
            <MenuItemStyled
              key={item ?? "none"}
              value={item ?? emptyGroupingValue}
              selected={item === (field.config.grouping ?? emptyGroupingValue)}
              disabled={disabledReason !== undefined}
              onClick={() => {
                if (disabledReason === undefined) {
                  updateGrouping(item ?? null);
                }
              }}
            >
              {disabledReason === undefined ? (
                label
              ) : (
                <Tooltip title={disabledReason}>
                  <Box component="span" sx={{ width: "100%", pointerEvents: "auto" }}>
                    {label}
                  </Box>
                </Tooltip>
              )}
            </MenuItemStyled>
          );
        })}
      </Select>
    </Grid>
  );
};

export default DateGroupingComponent;
